const normalizePathname = (pathname = '/') => {
  const clean = String(pathname || '/').split('?')[0].split('#')[0] || '/';
  return clean.startsWith('/') ? clean : `/${clean}`;
};

const matchesPrefix = (pathname, prefix) => {
  const cleanPath = normalizePathname(pathname);
  const cleanPrefix = normalizePathname(prefix).replace(/\/+$/, '') || '/';
  return cleanPath === cleanPrefix || cleanPath.startsWith(`${cleanPrefix}/`);
};

export const JG_RADIO_DOCK_PLACEMENTS = Object.freeze({
  DEFAULT: 'default',
  CHAT_COMPACT: 'chat-compact',
  MAP_COMPACT: 'map-compact',
  INTAKE_FLOW: 'intake-flow',
});

export const getJGRadioDockPlacement = (pathname = '/') => {
  const cleanPathname = normalizePathname(pathname);

  if (cleanPathname.replace(/\/+$/, '') === '/hitlab/intake') {
    return JG_RADIO_DOCK_PLACEMENTS.INTAKE_FLOW;
  }

  if (matchesPrefix(cleanPathname, '/messenger')) {
    return JG_RADIO_DOCK_PLACEMENTS.CHAT_COMPACT;
  }

  if (matchesPrefix(cleanPathname, '/playermap')) {
    return JG_RADIO_DOCK_PLACEMENTS.MAP_COMPACT;
  }

  return JG_RADIO_DOCK_PLACEMENTS.DEFAULT;
};
